// hooks/useUserAutocomplete.ts
import { useEffect, useState } from 'react'
import { useUsers } from '../useUsers'
import { useUsersById } from '../../customHooks/useUsersById'
import { User } from 'types'

export const useUserAutocomplete = (initialUserIds: string[] | string | undefined, multiple: boolean = false) => {
  const ids = Array.isArray(initialUserIds) ? initialUserIds : initialUserIds ? [initialUserIds] : []

  const { users: allUsers, isUsersLoading } = useUsers(true, ['allUsers'])
  const { users: fetchedUsers, isUsersByIdLoading } = useUsersById(ids)
  const [selectedUser, setSelectedUser] = useState<User[] | User | null>(multiple ? [] : null)

  useEffect(() => {
    if (!isUsersByIdLoading) {
      if (multiple) {
        setSelectedUser(fetchedUsers)
      } else if (fetchedUsers.length > 0) {
        setSelectedUser(fetchedUsers[0])
      } else {
        setSelectedUser(null)
      }
    }
  }, [isUsersByIdLoading, fetchedUsers, multiple])

  return {
    allUsers,
    selectedUser,
    setSelectedUser,
    isUsersLoading: isUsersLoading || isUsersByIdLoading,
  }
}
